(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["egcg-product-scale"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-egcg-scale]').forEach((scale) => {
    const items = [...scale.querySelectorAll('.egcg-scale__item')];
    const current = scale.querySelector('.egcg-scale__item.is-current') || items[0];
    const infoValue = scale.querySelector('[data-egcg-info-value]');

    const preview = (item) => {
      scale.style.setProperty('--egcg-marker-position', item.dataset.egcgPosition);
      infoValue.textContent = item.dataset.egcgValue;
    };

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => preview(item));
      item.addEventListener('focus', () => preview(item));
    });

    scale.addEventListener('mouseleave', () => preview(current));
    scale.addEventListener('focusout', (event) => {
      if (!scale.contains(event.relatedTarget)) preview(current);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
